import { useState, useEffect } from 'react';
import { shouldPromptToInstall } from '../utils/pwa';

const MobileInstallPrompt = ({ installPrompt, onInstallClick }) => {
  const [showBanner, setShowBanner] = useState(false);
  
  // Check if we should show the install banner
  useEffect(() => {
    // Only show the banner if we should prompt to install
    const shouldShow = shouldPromptToInstall(installPrompt);
    
    // Add a small delay to avoid showing the banner immediately on load
    if (shouldShow) {
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [installPrompt]);
  
  // Handle dismiss banner
  const handleDismiss = () => {
    setShowBanner(false);
    
    // Store in localStorage that the user dismissed the banner
    // Will hide it for 7 days
    localStorage.setItem('pwa_prompt_dismissed', Date.now().toString());
  };
  
  // Handle install click
  const handleInstall = () => {
    // Call the parent's install click handler
    onInstallClick();
    // Hide the banner
    setShowBanner(false);
  };
  
  // If banner shouldn't be shown, return null
  if (!showBanner) {
    return null;
  }
  
  return (
    <div className="mobile-install-prompt">
      <div className="mobile-install-prompt-content">
        <img src="/logo192.png" alt="App Icon" className="mobile-install-prompt-icon" />
        <div className="mobile-install-prompt-text">
          <h3>Install WellFed Cats App</h3>
          <p>Install our app for a better experience!</p>
        </div>
      </div>
      <div className="mobile-install-prompt-actions">
        <button onClick={handleDismiss} className="mobile-install-prompt-dismiss">
          Not now
        </button>
        <button onClick={handleInstall} className="mobile-install-prompt-install">
          Install
        </button>
      </div>
    </div>
  );
};

export default MobileInstallPrompt; 